import { useUsuario } from '../context/UsuarioContext';
import { Card } from './ui';
import FormularioIdPaciente from './FormularioIdPaciente';

/**
 * Pantalla intermedia: si no hay un ID de paciente cargado, lo pide.
 * Se usa en Buscar y en Mis turnos (no hay sesión en esta iteración).
 */
export default function RequerirPacienteId({ titulo = 'Necesitamos tu ID', children }) {
  const { pacienteId, setPacienteId } = useUsuario();

  if (pacienteId) return children;

  return (
    <Card style={{ maxWidth: 460, margin: '24px auto' }}>
      <h2>{titulo}</h2>
      <p style={{ color: 'var(--c-text-muted)' }}>
        En esta etapa no hay sesión: ingresá tu ID de paciente para continuar.
      </p>
      <FormularioIdPaciente onConfirmar={setPacienteId} />
    </Card>
  );
}
